export default __webpack_public_path__ + "static/media/welcome_bg@2x.dcdc8eb5.png";